import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components";
import { strings } from "../utils";
import { getAllBlogs, deleteBlog } from "../../src/utils/methods.js";
import BlogArrowIcon from "../components/Icons/blogsArrow.jsx";
import { DefaultBlogImage } from "../assets/images/index.js";
import ModalScreen from "../components/modal.jsx";
import DeleteIcon from "../components/Icons/deleteIcon.jsx";
import { CircularProgress } from "@mui/material";

const Blogs = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedBlogId, setSelectedBlogId] = useState(null);
  const [loading, setLoading] = useState(null);
  const [blogs, setBlogs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBlogs = async () => {
      setLoading(true);
      try {
        const blogData = await getAllBlogs();
        setBlogs(blogData);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogs();
  }, []);

  const handleAddBlog = () => navigate(`/blog/edit/new`);

  const handleClickOpen = (blogId) => {
    setSelectedBlogId(blogId);
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
    setSelectedBlogId(null);
  };

  const handleDeleteBlog = async () => {
    try {
      if (selectedBlogId) {
        await deleteBlog(selectedBlogId);
        setBlogs((prevBlogs) =>
          prevBlogs.filter((blog) => blog.id !== selectedBlogId)
        );
      }
      handleClose();
    } catch (error) {
      console.error("Error deleting blog:", error);
    }
  };

  const handleOpenExternalPage = (url) => {
    if (url) {
      const fullUrl = `https://www.exeonic.com/blog/${url}`;
      window.open(fullUrl, "_blank");
    }
  };

  return (
    <div className="container px-auto py-6 bg-border h-full overflow-scroll">
      <div className="flex justify-between mx-10 mb-8">
        <p className="text-[32px] font-semibold">{strings["BlogPageTitle"]}</p>
        <Button onClick={handleAddBlog}>{strings["AddBlogsBtn"]}</Button>
      </div>

      {loading ? (
        <div className="flex justify-center items-center ">
          <CircularProgress />
        </div>
      ) : blogs.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mx-10 ">
          {blogs.map((blog) => (
            <div
              key={blog.id}
              className="border rounded-2xl p-4 shadow-md flex flex-col justify-between"
            >
              <img
                src={`${blog.blogImage}?t=${new Date().getTime()}`}
                alt={blog.title}
                className="h-[120px] object-cover w-full rounded-md"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = DefaultBlogImage;
                }}
              />
              <p className="text-sm font-semibold text-primary pt-3">
                {blog.type}
              </p>
              <div
                className="flex justify-between py-3 cursor-pointer hover:opacity-80"
                onClick={() => handleOpenExternalPage(blog.id)}
              >
                <h2 className="text-2xl font-semibold">{blog.title}</h2>
                <BlogArrowIcon />
              </div>
              <div className="flex gap-x-2 w-full">
                <Button
                  variant="outlineArrow"
                  classes="border-primary text-primary !w-full justify-center"
                  onClick={() => navigate(`/blog/edit/${blog.id}`)}
                >
                  {strings["blogEditBtn"]}
                </Button>
                <Button
                  classes="!w-full justify-center"
                  onClick={() => handleClickOpen(blog.id)}
                >
                  {strings["DeleteBtn"]}
                </Button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex w-full justify-center items-center mt-10">
          <p>No blogs found.</p>
        </div>
      )}

      <ModalScreen
        open={openDialog}
        onClose={handleClose}
        onConfirm={handleDeleteBlog}
        title={strings["deleteTitle"]}
        description={strings["deleteDesc"]}
        confirmButtonText={strings["DeleteBtn"]}
        cancelButtonText={strings["cancelBtn"]}
        hideClass="hidden"
        icon={DeleteIcon}
      />
    </div>
  );
};

export default Blogs;
